"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUi = setUi;
exports.search = search;
exports.clear = clear;
exports.setPage = setPage;
exports.setSortColumn = setSortColumn;
exports.setResultPropertySortColumn = setResultPropertySortColumn;
function setUi(propertyName, value) {
    return {
        type: "advanced-product-search/SET-UI",
        payload: {
            propertyName,
            value
        }
    };
}
function search() {
    return {
        type: "advanced-product-search/SEARCH"
    };
}
function clear() {
    return {
        type: "advanced-product-search/CLEAR"
    };
}
function setPage(page) {
    return {
        type: "advanced-product-search/SET-PAGE",
        payload: {
            page
        }
    };
}
function setSortColumn(columnName) {
    return {
        type: "advanced-product-search/SET-SORT-COLUMN",
        payload: {
            columnName
        }
    };
}
function setResultPropertySortColumn(propertyName) {
    return {
        type: "advanced-product-search/SET-RESULT-PROPERTY-SORT-COLUMN",
        payload: {
            propertyName
        }
    };
}
//# sourceMappingURL=actions.js.map